import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { OverviewService } from "../../services/api/overview.service";

const formatYAxis = (value: number): string => `${value / 1000}K`;

const formatTooltipValue = (value: number): string => `₹ ${value.toFixed(2)}`;

interface CustomTooltipProps {
  active?: boolean;
  payload?: { value: number }[];
  label?: string;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const value = payload[0].value;
    return (
      <div className="bg-white p-3 shadow-lg rounded-lg border">
        <p className="text-gray-600">{label} 00:00</p>
        <p className="text-xl font-semibold">₹ {value.toFixed(2)}</p>
      </div>
    );
  }
  return null;
};

const RevenueChart: React.FC = () => {
  const [data, setData] = useState<{ month: string; revenue: number }[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    OverviewService.fetchRevenueStats()
      .then((stats) => {
        setData(stats);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching revenue stats:", error);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading...</p>;

  return (
    <div className="p-2 bg-white border border-gray-400/60 rounded-md flex items-center justify-center flex-col gap-2 w-[100%]">
      <div className="w-full h-80 p-4">
        <h2 className="text-2xl font-semibold mb-4">Revenue</h2>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{ fill: "#666" }} />
            <YAxis tickFormatter={formatYAxis} axisLine={false} tickLine={false} tick={{ fill: "#666" }} />
            <Tooltip content={<CustomTooltip />} />
            <Line type="monotone" dataKey="revenue" stroke="#8884d8" strokeWidth={2} dot={false} activeDot={{ r: 8, fill: "#8884d8" }} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default RevenueChart;
